import React from "react";
import SectionShell from "./SectionShell";

const QUOTES = [
  {
    body: "Biagio quietly restructured our corporate life coverage and shaved almost a decade off my planned exit timeline. It didn't feel like a sales meeting. It felt like advice from a family friend who happened to be very good at his job.",
    author: "M. Iqbal",
    role: "Owner-Operator · Mississauga",
  },
  {
    body: "He was the third advisor we met with. The first two were pitching products in the first meeting. Biagio spent an hour understanding our life. Two years in, we're still finding out how much he thought of that we hadn't.",
    author: "The Vandersterre Family",
    role: "Family Client · Toronto",
  },
  {
    body: "The reviews are quarterly and they actually happen. My accountant, my lawyer, and Biagio share the same working file. That coordination alone has been worth it.",
    author: "J. Palwa-Lajara",
    role: "Executive · Etobicoke",
  },
];

export default function Testimonials() {
  return (
    <SectionShell
      id="testimonials"
      eyebrow="Client voices"
      title="Words we've earned, and keep earning."
      data-testid="testimonials"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {QUOTES.map((q, i) => (
          <figure
            key={q.author}
            className="flex flex-col rounded-2xl bg-white border border-[#E6E2D8] p-8 shadow-[0_8px_30px_rgba(11,31,63,0.04)] transition-[border-color,transform] duration-300 hover:border-[#B08D57]/60 hover:-translate-y-1"
            data-testid={`testimonial-${i}`}
          >
            <div className="font-display text-5xl leading-none text-[#B08D57]">&ldquo;</div>
            <blockquote className="text-[#0F1B2D] text-[15px] leading-relaxed mt-2 flex-1">
              {q.body}
            </blockquote>
            <figcaption className="mt-8 pt-5 border-t border-[#E6E2D8]">
              <div className="font-display text-[#0B1F3F]">{q.author}</div>
              <div className="text-[#5A6476] text-xs mt-1">{q.role}</div>
            </figcaption>
          </figure>
        ))}
      </div>
      <p className="text-[#8C93A1] text-xs mt-8 max-w-2xl">
        Names and identifying details are edited with client permission. Past
        results are not indicative of future performance.
      </p>
    </SectionShell>
  );
}
